(async () => {
  await import(`animate.css`);
  await import(`./animate.scss`);
})();
export default {};
